import styled from 'styled-components';

export const BannerWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: #1a1a2e;
  border-top: 2px solid var(--accent-color);
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  box-shadow: 0 -4px 20px rgba(0,0,0,0.4);

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 14px 16px;
  }
`;

export const BannerText = styled.p`
  margin: 0;
  font-size: 13px;
  color: rgba(255,255,255,0.82);
  line-height: 1.5;
  flex: 1;

  a {
    color: var(--accent-color);
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const BannerButtons = styled.div`
  display: flex;
  gap: 10px;
  flex-shrink: 0;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const BtnAceptar = styled.button`
  background: var(--accent-color);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 9px 20px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;

  &:hover { opacity: 0.9; }

  @media (max-width: 600px) { flex: 1; }
`;

export const BtnEsenciales = styled.button`
  background: transparent;
  color: rgba(255,255,255,0.7);
  border: 1px solid rgba(255,255,255,0.25);
  border-radius: 8px;
  padding: 9px 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover { border-color: rgba(255,255,255,0.5); color: #fff; }

  @media (max-width: 600px) { flex: 1; }
`;
